module.exports = __webpack_public_path__ + "img/prizesTab1.1cd3a357.png";